<template>
  <VWidget :title="$t('Payment transactions')">
    <div slot="widget-content">
      <v-data-table
        :headers="headers"
        :items="order.transactions"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-left">
            <span class="d-block">{{ props.item.provider }}</span>
            <small>{{ props.item.id }}</small>
          </td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.payment_type }}</td>
          <td class="text-xs-left">{{ props.item.amount | money }}</td>
          <td class="text-xs-center">
            <v-chip
              :color="statusColor[props.item.status]"
              label
              small
              text-color="white"
            >
              {{ $t(statuses[props.item.status]) }}
            </v-chip>
          </td>
          <td class="text-xs-center">
            <span v-if="!props.item.created_at">-</span>
            <span v-else>{{ props.item.created_at | timezone }}</span>
          </td>
        </template>
      </v-data-table>
    </div>
  </VWidget>
</template>

<script>
export default {
  name: 'OrderSingleTransactions',

  props: {
    order: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      statuses: {
        0: 'New',
        1: 'Pending',
        2: 'Finished',
        3: 'Canceled',
        4: 'Error'
      },
      statusColor: {
        0: 'grey',
        1: 'light-blue',
        2: 'green',
        3: 'yellow',
        4: 'error'
      }
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Provider'), value: 'provider' },
        { text: this.$t('Payment type'), value: 'type' },
        { text: this.$t('Transaction type'), value: 'transaction_type' },
        { text: this.$t('Amount'), value: 'amount' },
        { text: this.$t('Status'), value: 'status', align: 'center' },
        { text: this.$t('Created At'), value: 'created_at', align: 'center' }
      ]
    }
  }
}
</script>
